@if(buildingChange()) {
    <div class="building-change-wrapper" [ngClass]="{ 'gradient-background': infoExpaned }" (click)="onExpandClicked()">
        <div class="header-row">
            <div class="information">
                <div class="column-50">
                    <div class="header">{{ buildingChange().buildingType }}</div>
                </div>
                <div class="column-50 extra-padding">
                    <div>{{ buildingChange().buildingStatus }}</div>
                    <div>{{ getDateByBuildingStatus(buildingChange().buildingStatus) | date:'dd.MM.yyyy' }}</div>
                    <div class="desktop-view">BRA {{ buildingChange().residentialUsableArea }}m²</div>
                </div>
            </div>
            <div class="expanded-icon">
                <ev-expanded-icon [expanded]="infoExpaned" [size]="18"></ev-expanded-icon>
            </div>
        </div>
        <div class="table" [ngClass]="{ expanded: infoExpaned }">          
            <info-table [defaultBackgoundColor]="false" [left]="changeDisplayTable().leftcolumn" [right]="changeDisplayTable().rightcolumn"> </info-table>
        </div>
    </div>
}
